export const MARKETS_FI = {
    match_odds_ft: "Ottelun tulos (koko peli)",
    match_odds_ht: "Ottelun tulos (1. puoliaika)",
    goals_ft: "Yli/Alle {{line}} maalia (koko peli)",
    goals_ht: "Yli/Alle {{line}} maalia (1. puoliaika)",
    player_scores: "{{player}} tekee maalin (koko peli)",
    corners_ft: "Kulmat yli/alle {{line}} (koko peli)",
    cards_ft: "Kortit yli/alle {{line}} (koko peli)",
    draw: "Tasapeli",
    over: "Yli {{line}}",
    under: "Alle {{line}}",
    yes: "Kyllä",
    no: "Ei",
}
